module.exports = __webpack_public_path__ + "img/4.2ef33bd2.jpg";